export default "__VITE_ASSET__C8ZJP1i7__"